import moment, { Moment } from 'moment';
import { Cloneable } from '../Utils/Cloneable';
import { RawWaitlistData, WaitlistData, WaitlistStatus } from './types';

export class WaitlistModel extends Cloneable {
  id: string;
  email: string;
  status: WaitlistStatus;
  createdAt: Moment | null;

  constructor(rawData?: RawWaitlistData) {
    super();
    this.id = rawData?.id ?? '';
    this.email = rawData?.email ?? '';
    this.status = rawData?.status ?? WaitlistStatus.PENDING;
    this.createdAt = rawData?.created_at ? moment(rawData.created_at) : null;
  }

  public setStatus(status: WaitlistStatus): void {
    this.status = status;
  }

  public toJSON(): WaitlistData {
    return {
      id: this.id,
      email: this.email,
      status: this.status,
      createdAt: this.createdAt
    };
  }
}

export default WaitlistModel;
